import { onCleanup, onMount } from "solid-js";

import { useLoginByGoogle } from "@/api/clientApi/login";
import { ReportUserAuthData } from "@/api/clientApi/userKyc.ts";
import { toast } from "@/components/Base/Toaster/Toaster";
import { useDialog } from "@/components/Dialogs/useDialog.ts";
import { useRouter } from "@/hooks/useRouter";
import { pubSub } from "@/lib/PubSub";
import { ReactNativeSDK } from "@/lib/sdk/reactNative";
import { sdkManager } from "@/lib/sdk/sdkManager";
import { SDKName } from "@/lib/sdk/types";
// import { requestTwaData } from "@/lib/twaBridge";
import { setCurGameId } from "@/stores/gameStore";
import { KYCStore } from "@/stores/kycStore";
import { getUserInfo } from "@/stores/userStore";
import { PubSubEvents } from "@/types/PubSub";

import { useSendMsgToIframe } from "./game/useSendMsgToIframe";
import { useClick } from "./useClick";
import { getHomePopups } from "./usePopup";

declare global {
  interface Window {
    onReactNativeMessage?: (msg: string) => void;
  }
}

export interface NativeMessage {
  [key: string]: unknown;
}

export function useMessageListener(
  callback?: (msg: NativeMessage, event: MessageEvent) => void,
) {
  const { back, push, toDeposit } = useRouter();
  const { operateDialog } = useDialog();
  const { click } = useClick();

  const listenFlagUpdate = (count: number) => {
    if (count > 0) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  };

  onMount(() => {
    const handler = async (event: MessageEvent) => {
      try {
        const msg =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        const cmd =
          msg?.cmd || msg?.event || msg?.eventType || msg?.name || msg?.type;
        switch (cmd) {
          case "event_link":
            click(msg.click_id, msg.click_params);
            break;
          case "googleLogin":
            console.log("Got token from iframe:", msg.credential);
            await useLoginByGoogle(msg.credential);
            back();
            await getUserInfo(true);
            sdkManager.tdReportEvent("google_login", {});
            getHomePopups(); // google 登入后导转回首页需要调用
            break;
          case "topay":
            console.log("Got topay from iframe:", msg);
            toDeposit();
            break;
          case "exit":
            if (msg.param?.tip) {
              toast.error(msg.param.tip);
            }
            console.log("Got exit from iframe:", msg);
            setCurGameId(0, "", "", "");
            push("/");
            break;
          case "tologin":
          case "PLACE_BET_CLICKED_NOT_LOGGED_IN": //first体育
            //打开登录窗口
            push("/login");
            break;
          case "first_sport_ready":
            {
              const { updateFirstSportData } = useSendMsgToIframe();
              console.log("Got ready first_sport_readyfrom iframe:", msg);
              updateFirstSportData();
              // TODO: Implement updateFirstSportData without router primitives
            }
            break;
          //厂商1 4人脸认证结束事件 关闭弹窗
          case "step-completed":
          case "facematch":
          case "kyc-complete":
            if (
              cmd == "step-completed" &&
              event.data?.detail != "kyc-complete"
            ) {
              return;
            }

            ReportUserAuthData().finally(async () => {
              // 更新kyc状态
              await KYCStore.getKycStatus();
              // 更新个人信息
              await getUserInfo();
              operateDialog("KycIframe");
            });
            break;
          case "close_kyc_iframe":
          case "kyc-close":
          case "close-modal":
            // 更新kyc状态
            await KYCStore.getKycStatus();
            operateDialog("KycIframe");
            operateDialog("KYC");
            break;
          case "Window.Redirect":
            if (msg.url && msg.url.includes("gameclose")) {
              setCurGameId(0, "", "", "");
              back();
            }
            break;
          default:
            break;
        }

        callback?.call(null, msg, event);
      } catch (e) {
        console.error("消息解析失败", e);
      }
    };

    window.addEventListener("message", handler);
    const wrappedHandler = (event: string) => {
      console.log("[wrappedHandler] event", event);
      try {
        const msg = JSON.parse(event);
        switch (msg.cmd) {
          case "close":
            console.log("Got close from React Native:", msg);
            sdkManager
              ?.getSDK<ReactNativeSDK>(SDKName.ReactNativeSDK)
              ?.sendToReactNative("closeh5", {});
            break;
          default:
            break;
        }
      } catch (e) {
        console.error("消息解析失败", e);
      }
    };

    window.onReactNativeMessage = wrappedHandler;
    pubSub.subscribe(PubSubEvents.AddFlag, listenFlagUpdate);
    pubSub.subscribe(PubSubEvents.RemoveFlag, listenFlagUpdate);
    onCleanup(() => {
      window.removeEventListener("message", handler);
      pubSub.unsubscribe(PubSubEvents.AddFlag, listenFlagUpdate);
      pubSub.unsubscribe(PubSubEvents.RemoveFlag, listenFlagUpdate);
      if (window.onReactNativeMessage) {
        delete window.onReactNativeMessage;
      }
    });
  });
}
